import { ChangeDetectionStrategy, Component, Directive, input } from '@angular/core';
import { DsIconComponent, DsIconName } from './icon.component';

@Directive({ selector: '[dsCard]', host: { class: 'ds-card' } })
export class DsCardDirective {}

@Component({
  selector: 'ds-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-card', '[class.ds-card--interactive]': 'interactive()' },
  template: '<ng-content />',
})
export class DsCardComponent {
  readonly interactive = input(false);
}

export type DsAlertTone = 'info' | 'success' | 'warning' | 'danger';
@Component({
  selector: 'ds-alert',
  imports: [DsIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'ds-alert',
    '[class.ds-alert--success]': "tone() === 'success'",
    '[class.ds-alert--warning]': "tone() === 'warning'",
    '[class.ds-alert--danger]': "tone() === 'danger'",
    '[attr.role]': "tone() === 'danger' ? 'alert' : 'status'",
  },
  template: `<ds-icon [name]="icon()" />
    <div>
      <strong>{{ title() }}</strong
      ><ng-content />
    </div>`,
})
export class DsAlertComponent {
  readonly tone = input<DsAlertTone>('info');
  readonly title = input.required<string>();
  protected icon(): DsIconName {
    return this.tone() === 'success' ? 'check' : this.tone() === 'info' ? 'info' : 'warning';
  }
}

@Component({
  selector: 'ds-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-badge', '[attr.data-tone]': 'tone()' },
  template: '<ng-content />',
})
export class DsBadgeComponent {
  readonly tone = input<'neutral' | 'info' | 'success' | 'warning' | 'danger'>('neutral');
}

@Component({
  selector: 'ds-progress',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-progress' },
  template: `<div class="ds-progress__labels">
      <span>{{ label() }}</span
      ><strong>{{ value() }}%</strong>
    </div>
    <div
      class="ds-progress__track"
      role="progressbar"
      [attr.aria-label]="label()"
      [attr.aria-valuenow]="value()"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <span [style.width.%]="value()"></span>
    </div>`,
})
export class DsProgressComponent {
  readonly value = input(0);
  readonly label = input('Progress');
}
